import { ComponentType, Fragment, Key, useEffect, useState } from "react";
import parse from 'html-react-parser';
import RadioButton from "./RadioButton";
import { FormElement } from "./FormElement";
import { FormDataType, OptionType, RadiogroupDependingElementType, TextareaElementType } from "../helpers/types";
import { isElementVisible } from "../helpers/restrictedVisibility";

type Props = {
    checked: number | string;
    onCheck: (value: string | number) => void;
    updateForm: (name: string, value: string | null) => void;
    formData?: FormDataType;
    FormElementAlt?: ComponentType<TextareaElementType>;
}

const RadioGroupDepending = (props: RadiogroupDependingElementType & Props) => {
    const { alternatives, label, classes, checked, onCheck, depends, updateForm, formData = {}, FormElementAlt, description } = props;
    const [localDependencies, setLocalDependencies] = useState<TextareaElementType[]>([]);

    useEffect(() => {
        if (checked) {
            const filteredDepends = depends.find(
                (dep) => dep.radiovalue === checked || dep.radiovalue === checked.toString()
            );
            const dependentElements = filteredDepends?.innerElements || [];
            setLocalDependencies(dependentElements);
        } else {
            setLocalDependencies([]); // Clear dependencies when unchecked
        }
    }, [checked, depends]);

    const handleChange = (value: string | number) => {
        onCheck(value);

        depends.forEach((item) => {
            if (value !== item.radiovalue) {
                // Remove inner elements from form data
                item.innerElements.forEach((element) => {
                    updateForm(element.name, null);
                });
            }
        });
    };

    if (!alternatives || alternatives.length === 0) return null;

    return (
        <>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <div className={`radio-group mb-4 ${classes}`}>
                {alternatives?.map((item: OptionType, index: number) => (
                    <Fragment key={item.label + index}>
                        {/* {separator && index > 0 ? <span></span> : null} */}
                        <RadioButton
                            label={item.label}
                            active={checked === item.value}
                            onCheck={handleChange}
                            value={item.value}
                        />
                    </Fragment>
                ))}
            </div>

            {localDependencies.map((item: TextareaElementType, index: Key) => {
                // Også oppfølgings­spørsmål kan ha "Begrenset visning" satt
                // i form-builder — skjul disse hvis kriteriene ikke passerer.
                if (!isElementVisible(item.restrictedVisibility, formData)) {
                    return null;
                }
                const ComponentToRender = FormElementAlt || FormElement;
                return (
                    <div className="mb-2 mb-lg-4" key={item.name || index}>
                        <ComponentToRender {...item} />
                    </div>
                );
            })}
        </>
    )
}

export default RadioGroupDepending;